/** Dan i mesec uvek sa vodećom nulom (npr. 06. 11. 2025., ne 6. 11. 2025.). */
const billingDayMonthYear = { day: '2-digit', month: '2-digit', year: 'numeric' };

/**
 * Prikaz datuma obračuna (YYYY-MM-DD sa servera, kalendarski dan u Beogradu)
 * u lokalnom formatu, bez američkog redosleda mesec/dan u ISO stringu.
 */
export function formatBillingYmdLocal(ymd, locale = 'sr-RS') {
  if (!ymd || typeof ymd !== 'string') return '—';
  const m = ymd.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!m) return ymd;
  const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  if (Number.isNaN(d.getTime())) return ymd;
  return d.toLocaleDateString(locale, billingDayMonthYear);
}

/** Samo datum (ISO string / Date) u istom stilu kao obračun — sa 2 cifre za dan i mesec. */
export function formatBillingInstantDate(isoOrDate, locale = 'sr-RS') {
  const d = isoOrDate instanceof Date ? isoOrDate : new Date(isoOrDate);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString(locale, billingDayMonthYear);
}

/** Datum i vreme (npr. kraj proba) — dan/mesec 2 cifre, sat/minut 2 cifre. */
export function formatBillingInstantDateTime(isoOrDate, locale = 'sr-RS') {
  const d = isoOrDate instanceof Date ? isoOrDate : new Date(isoOrDate);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString(locale, {
    ...billingDayMonthYear,
    hour: '2-digit',
    minute: '2-digit',
  });
}

/** Locale za i18n jezik (sr → sr-RS, inače en-GB za dan.mesec.god). */
export function billingDateLocaleForLanguage(lang) {
  if (!lang || String(lang).toLowerCase().startsWith('sr')) return 'sr-RS';
  return 'en-GB';
}
